import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {Observable} from "rxjs";
import {CellClickedEvent, ColDef, FirstDataRenderedEvent, GridReadyEvent} from "ag-grid-community";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {Order} from "../../../app.models";
import {MatDialog} from "@angular/material/dialog";
import {OrderSessionDialogComponent} from "./order-session-dialog/order-session-dialog.component";

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiUrl.getJWTToken()
    })
  }
  public orders = [
    { number: '#3258', date: 'March 29, 2018', status: 'Completed', total: '$140.00 for 2 items', invoice: true },
    { number: '#3145', date: 'February 14, 2018', status: 'On hold', total: '$255.99 for 1 item', invoice: false },
    { number: '#2972', date: 'January 7, 2018', status: 'Processing', total: '$255.99 for 1 item', invoice: true },
    { number: '#2971', date: 'January 5, 2018', status: 'Completed', total: '$73.00 for 1 item', invoice: true },
    { number: '#1981', date: 'December 24, 2017', status: 'Pending Payment', total: '$285.00 for 2 items', invoice: false },
    { number: '#1781', date: 'September 3, 2017', status: 'Refunded', total: '$49.00 for 2 items', invoice: false }, 
    { number: '#3981', date: 'December 24, 2017', status: 'Pending Payment', total: '$285.00 for 2 items', invoice: false },
    { number: '#5781', date: 'September 3, 2017', status: 'Refunded', total: '$49.00 for 2 items', invoice: false },
    { number: '#6258', date: 'March 22, 2019', status: 'Completed', total: '$140.00 for 2 items', invoice: true },
    { number: '#7145', date: 'February 14, 2020', status: 'On hold', total: '$255.99 for 1 item', invoice: false },
    { number: '#1972', date: 'January 10, 2018', status: 'Processing', total: '$255.99 for 1 item', invoice: true },
    { number: '#8971', date: 'October 3, 2019', status: 'Completed', total: '$73.00 for 1 item', invoice: true }
  ]
  public page: any;
  public count = 6;

  ngOnInit(): void {
  }

  public onPageChanged(event){
    this.page = event; 
    window.scrollTo(0,0); 
  }

  public getCourseListCount = ($param: any) => {
    return $param.data.orderItem.map(res=>res.quantity).reduce((a, b) => a + b, 0)
  };


  public pdfFileCellRender =  ($param: any)=>{
    return '<a href="' + $param.data.pdfFile + '">'+
              '<mat-icon>file_copy</mat-icon>'+
           '</a>';
  }
  public getStoreDetials = ($param: any) => {
    const userId= $param.value.id
    const storeName = this.storeList.find(store=>store.userId == userId)?.storeName;
    return '<a>'+storeName+'</a>'
  };
  public storeFilter(){
    return true;
  }
  public textMatcher(param): boolean{
    const storeName = this.storeList.find(store=>store.userId == param.data.user.id)?.storeName;
    if((param == undefined || param == null) && storeName == undefined){
      return true;
    }
    if(storeName.includes(param.filterText)){
      return true;
    }
    return false;
  }
  filterParams = {
    textMatcher:this.textMatcher.bind(this)
  }
  public columnDefs: ColDef[] = [
    { field: 'id', headerName:'מספר הזמנה', sortable: true, resizable: true},
    { field: 'user', headerName:'בית עסק', sortable: true, resizable: true, cellRenderer: this.getStoreDetials,enableValue: true, suppressMenu: true,filter: 'agTextColumnFilter', filterParams: this.filterParams},
    { field: 'submittedDate', headerName:'תאריך הגשת ההזמנה', sortable: true, resizable: true},
    { field: 'totalPrice', headerName:'סך הכל', sortable: true, resizable: true },
    { field: 'orderItem', headerName:'פרטי הזמנה', sortable: true, resizable: true , cellRenderer: this.getCourseListCount},
    { field: 'firstName', headerName:'שם פרטי', sortable: true, resizable: true },
    { field: 'lastName', headerName:'שם משפחה', sortable: true, resizable: true },
    { field: 'phone', headerName:'מספר טלפון', sortable: true, resizable: true },
    { field: 'email', headerName:'אימייל', sortable: true, resizable: true },
    { field: 'paymentCopy', headerName:'עותק חשבונית', sortable: true, resizable: true, cellRenderer:this.pdfFileCellRender },
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
  };

  // Data that gets displayed in the grid
  public rowData$!: Observable<any[]>;
  public storeData$!: Observable<any[]>;

  // For accessing the Grid's API
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private apiUrl:ApiUrl, public dialog: MatDialog) {}


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(event.target.innerWidth > 1500){
      this.agGrid.api.sizeColumnsToFit()
    }
  }

  // Example load data from sever
  private storeList = []
  onGridReady(params: GridReadyEvent) {
    this.storeData$ = this.http.get<any>(this.apiUrl.getStores(),this.options)
    this.storeData$.subscribe((res:any)=>{
      this.storeList = res.results.map(store=> {return {storeName:store.name, userId: store.user.id}})
      this.rowData$ = this.http
          .get<Order[]>(this.apiUrl.getOrder(),this.options);
    })

  }

  // Example of consuming Grid Event
  onCellClicked( e: CellClickedEvent): void {
    if(e.column.getColId() == "orderItem"){
      this.openSessionDialog(e.value)
    }
  }

  // Example using Grid's API
  clearSelection(): void {
    this.agGrid.api.deselectAll();
  }

  public openSessionDialog(sessions: any) {

    this.dialog.open(OrderSessionDialogComponent, {
      data: sessions
    })
  }

  onFirstDataRendered($event: FirstDataRenderedEvent<any>) {
    this.agGrid.api.sizeColumnsToFit();
  }

}
